import { Badge, Card, Col, Drawer, Flex, List, Modal, Row, Space, Tag, Timeline } from 'antd';
import { Alert, Button } from 'components/elements';
import { MY_REQUEST_TYPE } from 'features/myDocument/schemas/myRequestSchema';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarOutlined, EnvironmentOutlined, SwapOutlined, CheckCircleOutlined, WarningOutlined, ClockCircleOutlined, FileTextOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive';
import { Link, useNavigate } from "react-router-dom";
import { getMyLeaveRequestCount, getMyLeaveRequestPagingWithoutPending } from '../services/homeApi';
import { HOME_SLICE, setIsLoading, setLeaveRequestPagingWithoutPending, setMyLeaveRequestCount } from '../slices/homeSlice';

function useRequest(onOpenDrawer) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { currentCompany, currentEmployee } = useSelector((state) => state.company);
    const { leaveRequestPagingWithoutPending, isLoading, leaveRequestCount } = useSelector((state) => state?.[HOME_SLICE]);
    const { t, i18n } = useTranslation();
    const [total, setTotal] = useState(0);
    const isTabletOrMobile = useMediaQuery({ maxWidth: 1424 })
    const isOverScreen = useMediaQuery({ maxWidth: 1000 })
    const { roles } = useSelector((state) => state.company);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    // const [count, setCount] = useState(0);
    const [pagination, setPagination] = useState({ page: 0, size: 5, totalPages: null });
    const [openNotiOver, setOpenNotiOver] = useState(false)
    const [openModal, setOpenModal] = useState({
        title: "",
        isOpen: false,
        data: []
    })
    const pendingIcons = {
        Leave: { icon: <CalendarOutlined />, color: "#FFFFFF", bg: "#FF4136" },
        OffsiteWork: { icon: <EnvironmentOutlined />, color: "#FFFFFF", bg: "#0F7D25" },
        RedeemTime: { icon: <SwapOutlined />, color: "#FFFFFF", bg: "#6B8E00" },
        EndorseTime: { icon: <CheckCircleOutlined />, color: "#FFFFFF", bg: "#F79009" },
        WarningLetter: { icon: <WarningOutlined />, color: "#FFFFFF", bg: "#D60D0D" },
        CollectTime: { icon: <ClockCircleOutlined />, color: "#FFFFFF", bg: "#12B76A" },
        OverTime: { icon: <ClockCircleOutlined />, color: "#FFFFFF", bg: "#3060CF" },
        Document: { icon: <FileTextOutlined />, color: "#FFFFFF", bg: "#7C3AED" },
    };
    const showDrawer = () => {
        loadMore()
        setOpenNotiOver(true);
        setData([])
        onOpenDrawer?.();
    };
    const onClose = () => {
        setPagination({ page: 0, size: 5, totalPages: null })
        setData([])
        setOpenNotiOver(false);
    };

    const loadMore = async () => {
        setLoading(true);
        await getMyLeaveRequestPagingWithoutPending({
            page: pagination.page,
            size: pagination.size,
            companyId: currentCompany,
            employeeId: currentEmployee,
        }).then(res => {
            // dispatch(setLeaveRequestPagingWithoutPending(res?.data?.content))
            // console.log(res?.data?.content);
            setPagination({
                ...pagination,
                page: pagination.page + 1,
                totalPages: res.data?.totalPages
            })
            const newData = data.concat(res?.data?.content);
            setData(newData);
            setLoading(false);
            window.dispatchEvent(new Event('resize'));
        })
    };

    const onLoadMore = useCallback(
        () => {
            return (<div
                style={{
                    textAlign: 'right',
                    marginTop: 12,
                    height: 32,
                    lineHeight: '32px',
                }}
            >
                {pagination.page >= pagination.totalPages ?
                    <span></span>
                    : <Button size="small" onClick={loadMore}>{t('home.btn.view-all')}</Button>}
            </div>
            )
        },
        [pagination],
    )

    function tagByStatus(status) {
        switch (status) {
            case "Approved":
                return (<Badge color="#12B76A" text={status} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} />)
            case "อนุมัติ":
                return (<Badge color="#12B76A" text={status} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} />)
            case "อนุมัติคำขอ":
                return (<Badge color="#12B76A" text="อนุมัติ" style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} />)

            case "Rejected":
                return (<Badge color="#F15046" text={status} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} />)
            case "คำขอถูกยกเลิก":
                return (<Badge color="#F15046" text={status} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} />)
            case "ยกเลิกคำขอ":
                return (<Badge color="#F15046" text={status} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} />)
            case "คำขอถูกปฎิเสธ":
                return (<Badge color="#F15046" text="ถูกปฎิเสธ" style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} />)

            case "รอการคำนวณ":
                return (<Badge color="#FFBF1A" text="รออนุมัติ" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} />)
            case "รออนุมัติคำขอ":
                return (<Badge color="#FFBF1A" text="รออนุมัติ" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} />)
            case "Pending":
                return (<Badge color="#FFBF1A" text={status} style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} />)

            case "แบบร่าง":
                return (<Badge color="#667085" text="ฉบับร่าง" style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
            case "Draft":
                return (<Badge color="#667085" text={status} style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)

            default:
                return (<Badge color="#667085" text={status} style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
        }
    }

    function tagByStatusColor(status) {
        switch (status) {
            case "Approved":
                return "green"
            case "Cancelled":
                return "red"
            case "Rejected":
                return "red"
            default:
                return "blue"
        }
    }

    const pendingColors = [
        {
            name: "Leave",
            color: "#DBEDEF"
        },
        {
            name: "OffsiteWork",
            color: "#C2F5EE"
        },
        {
            name: "RedeemTime",
            color: "#D1FE97"
        },
        {
            name: "EndorseTime",
            color: "#F8F971"
        },
        {
            name: "WarningLetter",
            color: "#B2AFCA"
        },
        {
            name: "CollectTime",
            color: "#B3FDDC"
        },
        {
            name: "OverTime",
            color: "#BAFFBE"
        },
        {
            name: "Document",
            color: "#F6BAFF"
        },
    ]

    function notiRequestName(item) {
        switch (item?.requestName) {
            case "leaveRequest":
                return i18n.language == "en" ? "Leave Request" + "(" + item?.leaveTypeNameEn + ")" : "คำขอลางาน" + "(" + item?.leaveTypeName + ")"
            case "offsiteWork":
                return i18n.language == "en" ? "Offsite Work" : "คำขอปฏิบัติงานนอกสถานที่"
            case "collectTime":
                return i18n.language == "en" ? "Collect Time" : "คำขอสะสมเวลา"
            case "overTime":
                return i18n.language == "en" ? "Over Time" : "คำขอล่วงเวลา"
            case "redeemTime":
                return i18n.language == "en" ? "Redeem Time" : "คำขอแลกเวลา"
            case "endorseTime":
                return i18n.language == "en" ? "Endorse Time" : "คำขอรับรองเวลา"
            case "warningLetter":
                return i18n.language == "en" ? "Warning Letter" : "จดหมายเตือน"
            case "document":
                return i18n.language == "en" ? "Document" : "คำขอเอกสาร"

            default: return null
        }

    }

    function pendingName(nameEn) {
        switch (nameEn) {
            case "Leave":
                return i18n.language == "en" ? "Leave" : "คำขอลางาน"
            case "CollectTime":
                return i18n.language == "en" ? "Collect Time" : "คำขอสะสมเวลา"
            case "OffsiteWork":
                return i18n.language == "en" ? "Offsite Work" : "คำขอทำงานนอกสถานที่"
            case "OverTime":
                return i18n.language == "en" ? "Overtime" : "ล่วงเวลา"
            case "RedeemTime":
                return i18n.language == "en" ? "Redeem Time" : "คำขอแลกเวลา"
            case "EndorseTime":
                return i18n.language == "en" ? "Endorse Time" : "คำขอรับรองเวลา"
            case "WarningLetter":
                return i18n.language == "en" ? "Warning Letter" : "จดหมายเตือน"
            case "Document":
                return i18n.language == "en" ? "Document" : "คำขอเอกสาร"
            default: return null
        }

    }

    const getRelativeTime = useCallback(
        (date) => {
            const now = moment();
            const momentDate = moment(date);
            const today = moment().startOf('day');

            if (now.diff(momentDate, 'seconds') < 45) {
                return i18n.language == "en" ? 'New, ' : "ใหม่";
            } else if (now.diff(momentDate, 'minutes') < 60) {
                return momentDate.fromNow();
            } else if (momentDate.isSame(today, 'd')) {
                return i18n.language == "en" ? 'Today, ' : "วันนี้" + momentDate.format('HH:mm') + " น.";
            } else {
                return i18n.language == "en" ? momentDate.locale("en").format('DD/MM/YYYY,' + " HH : mm") : momentDate.add(543, "year").format("DD/MM/YYYY เวลา HH:mm น.");
            }
        },
        [i18n.language],
    )


    const getLeaveRequest = useCallback(
        async (params) => {
            try {
                dispatch(setIsLoading(true));
                await getMyLeaveRequestCount({
                    // ...pagination,
                    // page: pagination.page - 1,
                    companyId: params.currentCompany,
                    employeeId: params.currentEmployee,
                    approveStatusEn: ["Pending"]
                }).then(res => {
                    dispatch(setMyLeaveRequestCount(res.data))
                })
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch],
    )
    const getMyLeaveRequestPagingWithoutPendingList = useCallback(
        async (params) => {
            try {
                dispatch(setIsLoading(true));
                await getMyLeaveRequestPagingWithoutPending({
                    page: 0,
                    size: 4,
                    companyId: params.currentCompany,
                    employeeId: params.currentEmployee,
                }).then(res => {
                    dispatch(setLeaveRequestPagingWithoutPending(res?.data?.content))
                })
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch],
    )

    useEffect(() => {
        if (currentCompany && currentEmployee && roles.length != 0) {
            if (roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST|LEAVE")) {
                getLeaveRequest({ currentCompany, currentEmployee })
            }
            if (roles.includes("ACCESS_HOME")) {
                getMyLeaveRequestPagingWithoutPendingList({ currentCompany, currentEmployee, })
            }

        }
    }, [currentCompany, currentEmployee, roles])

    const getPendingTotal = useCallback(() => {
        return (leaveRequestCount ?? []).reduce((sum, item) => sum + Number(item.count ?? 0), 0);
    }, [leaveRequestCount]);

    const getPaddingList = useCallback(() => {
        if (!leaveRequestCount) return null;

        return (
            <List
                dataSource={leaveRequestCount}
                renderItem={(item) => {
                    const meta = pendingIcons[item.nameEn] ?? { icon: <FileTextOutlined />, color: "#667085", bg: "#EAEBEC" };
                    return (
                        <List.Item
                            style={{ cursor: "pointer", padding: "10px 0" }}
                            onClick={() => navigate("/my_document/my_request")}
                        >
                            <Flex align="center" justify="space-between" style={{ width: "100%" }}>
                                <Flex align="center" gap={10}>
                                    <Flex align="center" justify="center" style={{ width: 32, height: 32, borderRadius: "50%", backgroundColor: meta.bg, color: meta.color, flexShrink: 0, fontSize: 14 }}>
                                        {meta.icon}
                                    </Flex>
                                    <span style={{ fontWeight: 500, fontSize: 13 }}>{pendingName(item?.nameEn)}</span>
                                </Flex>
                                <span style={{ color: meta.bg, fontWeight: 600, fontSize: 13 }}>{item.count} {t("unit.item")}</span>
                            </Flex>
                        </List.Item>
                    );
                }}
            />
        );
    }, [leaveRequestCount, navigate, t]
    )


    const getListItem = useCallback(
        (content, onLoad, loading, modal = () => { }, isInDrawer = false) => {
            let language = i18n.language == "en" ? "En" : ""
            return (
                <div>
                    {modal()}
                    <List
                        dataSource={content}
                        pagination={false}
                        loadMore={onLoad}
                        loading={loading}
                        renderItem={(item) => (
                            <List.Item
                                size="small"
                                // itemLayout="vertical"
                                key={item.title}
                                style={{ backgroundColor: "#DBEDEE", padding: 10, borderRadius: 12, marginTop: 12, marginBottom: 12, cursor: "pointer" }}
                                onClick={() => {
                                    console.log("item", item);
                                    let temp = [...item.timeline];
                                    temp.sort((a, b) => new Date(b.date) - new Date(a.date));
                                    setOpenModal({ title: item, data: temp, isOpen: true })
                                }}
                            >
                                <List.Item.Meta
                                    // avatar={<Avatar src={item.avatar} />}
                                    // title={<a href={item.href}>{item.title}</a>} 
                                    description={<div>
                                        {getRelativeTime(moment(item.lastModifyDate))}
                                        {!isTabletOrMobile && !isInDrawer && (
                                            <div style={{ marginTop: 8, textAlign: "center" }}>
                                                {tagByStatus(item?.["approveStatus" + language])}
                                            </div>
                                        )}
                                    </div>}
                                    title={notiRequestName(item)}
                                />
                                {(isTabletOrMobile || isInDrawer) && (
                                    <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
                                        {tagByStatus(item?.["approveStatus" + language])}
                                    </div>
                                )}
                            </List.Item>
                        )}
                    >
                    </List>
                </div>)
        }
        ,
        [i18n],
    )

    const modalTimeLine = useCallback(
        (value) => {
            return (
                <Modal
                    onCancel={() => setOpenModal({ data: [], isOpen: false })}
                    open={openModal?.isOpen}
                    title={notiRequestName(openModal?.title)}
                    styles={{
                        header: {
                            marginBottom: 20
                        }
                    }}
                    footer={false}
                >
                    <Timeline
                        items={openModal?.data?.map(o => {
                            // console.log("o", moment(o.date));
                            let language = i18n.language == "en" ? "En" : ""
                            return ({
                                color: tagByStatusColor(o.approveStatusEn),
                                children: (
                                    <List.Item.Meta
                                        title={tagByStatus(o?.["approveStatus" + language])}
                                        description={
                                            <Space direction='vertical' size={1} style={{ marginTop: "8px" }}>
                                                <h4>{o.employee?.["name" + language] + " " + o.employee?.["surName" + language]} {getRelativeTime(moment(o.date))}</h4>
                                                <h5 style={{ fontWeight: "normal" }}>{o.description}</h5>
                                            </Space>
                                        }
                                    >
                                    </List.Item.Meta>
                                ),
                            })
                        })}
                    >
                    </Timeline>
                </Modal>
            )
        },
        [openModal, i18n],
    )
    const listNoti = useCallback(
        () => {
            const viewAll =
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 24,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button size="small" type="text" onClick={showDrawer}>
                        <span style={{ color: "#009DE6" }}>{t('home.btn.view-all')}</span>
                    </Button>
                </div>
                ;
            return getListItem(leaveRequestPagingWithoutPending, viewAll, isLoading, modalTimeLine)
        },
        [leaveRequestPagingWithoutPending, isLoading, modalTimeLine, t, showDrawer],
    )
    const drawer = useCallback(
        () => {
            return (<div>< Drawer destroyOnClose={true} title={t('home.notifications.title')} onClose={onClose} open={openNotiOver} >
                {getListItem(data, onLoadMore(), loading, modalTimeLine, true)}
            </Drawer ></div>)
        },
        [getListItem, openNotiOver, data, loading, modalTimeLine],
    )

    return {
        getPaddingList,
        getPendingTotal,
        leaveRequestPagingWithoutPending,
        listNoti,
        drawer,
        showDrawer,
        modalTimeLine
    };
}
export default useRequest;